/**
 * A cart line is a product *plus the exact variation chosen*, so the same duvet cover in 180 cm
 * and in 200 cm is two lines, not one.
 *
 * The variation cannot be compared by object identity. React state, `{...spread}` copies and the
 * localStorage round-trip (`JSON.parse(JSON.stringify(cart))`) all produce fresh objects for equal
 * selections, so `a.attributes === b.attributes` is false even when the customer picked the same
 * size twice. Derive a stable string instead.
 *
 * `tuckAllowance` is part of the identity: the same mattress height with and without the extra
 * 5 cm are made differently and priced differently.
 */
export const cartLineKey = (item) => {
  if (!item) return '';

  const attributes = item.attributes || {};
  const variation = Object.keys(attributes)
    .sort()
    .map((name) => {
      const chosen = attributes[name] || {};
      // `id` identifies the option row; fall back to the displayed value for older carts.
      return `${name}:${chosen.id ?? chosen.value ?? ''}`;
    })
    .join('|');

  const tuck = item.tuckAllowance == null ? '' : String(item.tuckAllowance);

  return `${item.id}#${variation}#${tuck}`;
};

/** True when two cart entries are the same product in the same variation. */
export const isSameCartLine = (a, b) => cartLineKey(a) === cartLineKey(b);
